// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 94 ? "Login" : chunkId) + "." + {"94":"134b7760","404":"68d7f22c","504":"7af67a70","659":"e26794e6","826":"f2ab72f2","924":"0e6cc1e5","929":"546c2fee","976":"11a07779"}[chunkId] + ".chunk.css";
};